'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    (0, _jquery2.default)('.barRating', this).each(function () {
        var initialRating = 0;
        var rating = (0, _jquery2.default)(this).siblings("[data-name='barRatingValue']")[0].value;
        var barRatingReadOnly = (0, _jquery2.default)(this).siblings("[data-name='barRatingReadOnly']")[0].value === "True";
        var linkToUserReview = (0, _jquery2.default)(this).siblings("[data-name='linkToUserReview']")[0].value === "True";
        var productId = (0, _jquery2.default)(this).siblings("[data-name='productId']")[0].value;

        if (rating !== "") {
            initialRating = parseInt(rating);
        }

        (0, _jquery2.default)(this).barrating({
            theme: '', // my own theme
            initialRating: initialRating,
            deselectable: false,
            readonly: barRatingReadOnly,
            onSelect: function onSelect(value, text, event) {
                if (typeof event !== 'undefined') {

                    productRatingService.addRating(productId, value).done(function () {
                        _notify2.default.success(Resx.App.BarRatingThanksForAdding);

                        if (linkToUserReview) {
                            (0, _jquery2.default)("#addNewUserReview").prop('disabled', false);
                        }
                    }).fail(function (result) {
                        _notify2.default.error(Resx.Validation.UnauthorizedDataOperation);
                    });
                }
            }
        });
    });
};

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _notify = require('linksoft/notify');

var _notify2 = _interopRequireDefault(_notify);

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('App', 'Validation');

var productRatingService = abp.services.api.productRating;

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/barRating.js
// module id = 1057
// module chunks = 1